import React, {useEffect, useState} from 'react';

import "react-datepicker/dist/react-datepicker.css";
import {useSearchParams} from "react-router-dom";

const CreditCardPaymentSuccess = (props) => {
  const [searchParams] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(true);
  const [inputValues, setInputValues] = useState({
    policyNumber: '',
    paymentFrequency: '',
    insuranceCover: '',
    vehicleValue: ''
  });
  //let url = 'http://localhost:8080/edge';
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';

  useEffect(() => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let renewalId = encodeURIComponent(params.get('uuid'));
    let token = encodeURIComponent(params.get('token'));
    window.location.href = `/vehicle?id=${renewalId}&token=${token}&back=yes`;
  }, [])


  return (
      <>

      </>
  );

}

export default CreditCardPaymentSuccess;
